<ng-container *transloco="let t">
  <div class="d-flex justify-content-center pt-3" [class.load-more-wrapper]="!removeBottomPadding" [class.pb-70-30]="!removeBottomPadding">
    <a class="text-black fw-semibold text-uppercase" (click)="handleClick()">
      {{ t('app.common.load.more') }}
    </a>
  </div>
</ng-container>
